import styled from "styled-components";

export const PeopleEditorContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 8px 82px;
  gap: 16px;
  flex: 1;
  margin-bottom: 113px;
`;
